import { render, staticRenderFns } from "./rightbar.vue?vue&type=template&id=ffd01cb2&"
import script from "./rightbar.vue?vue&type=script&lang=js&"
export * from "./rightbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports